import getRequestOptions from "../utils/getRequestOptions";
import IPutItem from "../interfaces/IPutItem";

const usePutItem = () => {

    /** Put item - update item
     * @param {URL} url - API endpoint url f.e. 'https://example.com/api/v1/users'
     * @param {any} options.body - Object which describes the created item
     * @param {string} [options.accessToken] - Access token is added to Authentication header if defined
     * @param {string} [options.contentType] - Content Type f.e "multipart/form-data". Default is "application/json"
     * @param {AbortSignal} [options.abortSignal] - signal to abort the 
     **/
    const putItem = async (url: URL, options?: IPutItem) => {
        try {

            const requestOptions = getRequestOptions({ method: "PUT", ...options });

            const response = await fetch(url, requestOptions);

            let data = null;

            // Try to Parse JSON data from the response
            try {
                data = await response.json();
            } catch (err) {
                data = [];
            }

            // Return an object containing both the raw response and the parsed data
            const resObj = {
                statusText: response.statusText,
                status: response.status,
                ok: response.ok,
                url: response.url,
                data: data,
            };

            // Throw error if result is not ok
            if (!response.ok) throw resObj;

            return resObj;

        } catch (error: any) {
            if (error.name === 'AbortError') {
                return { requestAborted: true, ...error }
            } else {
                throw error;
            }
        }

    }

    return putItem;

}

export default usePutItem;
